import { Box, Grid, Typography } from "@mui/material";
import moment from "moment";
import { useEffect } from "react";
import { MuiStack } from "../../../../../../../../components";
import StatusColor from "../../../../../../../../components/atoms/statusColor";
import { useAppSelector } from "../../../../../../../../store/hooks";
import { systemColor } from "../../../../../../../../theme/systemColor";
import { AdjustIconSVG, CheckStepperSVG } from "../../../../../../purchaseRequistion/assets/customIcons";
import { statusProgressListAPICall } from "../../../../../../purchaseRequistion/services/apiCall";
import { PurchaseRequisitionKeys } from "../../../../../../purchaseRequistion/services/entity";
export var StatusProgressComponent = function (props) {
    var _crud$PurchaseRequisi, _crud$PurchaseRequisi2;
    var rowData = props.rowData;
    var crud = useAppSelector(function (state) { return state.crud; });
    var statusProgress = (_crud$PurchaseRequisi = (_crud$PurchaseRequisi2 = crud[PurchaseRequisitionKeys.StatusProgressList]) === null || _crud$PurchaseRequisi2 === void 0 ? void 0 : _crud$PurchaseRequisi2.data) !== null && _crud$PurchaseRequisi !== void 0 ? _crud$PurchaseRequisi : [];
    useEffect(function () {
        var statusRequest = {
            ParentId: rowData === null || rowData === void 0 ? void 0 : rowData.id,
            EntityId: rowData === null || rowData === void 0 ? void 0 : rowData.SchemaId
        };
        statusProgressListAPICall({
            request: statusRequest
        });
    }, [rowData]);
    return /*#__PURE__*/ React.createElement(Box, {
        width: "100%"
    }, (statusProgress === null || statusProgress === void 0 ? void 0 : statusProgress.length) > 0 ? statusProgress === null || statusProgress === void 0 ? void 0 : statusProgress.map(function (step, index) { /*#__PURE__*/ return React.createElement(Grid, {
        container: true,
        spacing: 0,
        direction: 'row',
        minHeight: '90px',
        alignItems: "center",
        sx: {
            marginBottom: '8px'
        },
        key: index
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 1,
        height: '90px',
        minWidth: '24px'
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginRight: "8px"
        }
    }, !((step === null || step === void 0 ? void 0 : step.StatusName) === "DRAFT" || (step === null || step === void 0 ? void 0 : step.StatusName) === "Draft") ? /*#__PURE__*/ React.createElement(CheckStepperSVG, {
        sx: {
            color: systemColor.primary,
            width: '24px',
            height: '24px'
        }
    }) : /*#__PURE__*/ React.createElement(AdjustIconSVG, {
        sx: {
            color: (step === null || step === void 0 ? void 0 : step.StatusName) === "Cancelled" ? "error" : systemColor.primary
        },
        fontSize: "large"
    }), /*#__PURE__*/ React.createElement("div", {
        style: {
            marginTop: '5px',
            width: "1px",
            height: "58px",
            backgroundColor: '#dee4eb',
            marginBottom: "4px"
        }
    }))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 11,
        sx: {
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
            padding: '2px 0px 20px 0px'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        color: systemColor.lightGrey
    }, moment(step === null || step === void 0 ? void 0 : step.CreatedOn).format('DD MMM YYYY • h:mm A')), /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        bgcolor: systemColor.backgroundColor,
        borderRadius: '8px',
        minHeight: '48px',
        padding: '12px',
        mt: '0px'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "row",
        alignItems: "center",
        sx: {
            minHeight: '22px',
            minWidth: '58px',
            border: "1px solid #DEE4EB",
            borderRadius: "6px",
            columnGap: "5px",
            padding: "2px 8px 2px 8px",
            boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
            bgcolor: systemColor.white
        }
    }, step.StatusName == 'Cancelled' ? /*#__PURE__*/ React.createElement(StatusColor, {
        status: step === null || step === void 0 ? void 0 : step.StatusName
    }) : /*#__PURE__*/ React.createElement(React.Fragment, null), /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            width: 'max-content'
        },
        variant: "h6",
        id: "status-name"
    }, step === null || step === void 0 ? void 0 : step.StatusName))))); }) : /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        color: "textSecondary"
    }, "No status progress available."));
};
